/**
 * Created by shubham on 8/5/18.
 */

import { Component, Inject } from '@angular/core';
import { APPCONFIG } from '../config';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpService } from '../shared/services/http.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import { dialogComponent } from '../dialog/dialog.component';
import { HttpHeaders } from '@angular/common/http';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';// import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';


@Component({
    selector: 'emailTemplateComponent',
    template: require('./emailTemplate.component.html'),
    providers: [HttpService, SessionHandler]

})
export class EmailTemplateComponent {
    // public editor = ClassicEditor;

    dialogRef;
    userDetails: any;
    isSystemAdmin:boolean = false;
    isCountryManager:boolean = false;
    countries = []
    selectedCountries = [];
    countryMessage = '';
    accessToken: string;
    languages = [{'id' : '0', 'name' : 'UK'},{'id' : '1', 'name' : 'SV'},{'id' : '2', 'name' : 'SR'},{'id' : '3', 'name' : 'SL'}
    ,{'id' : '4', 'name' : 'SK'},{'id' : '5', 'name' : 'SH'},{'id' : '6', 'name' : 'RU'},{'id' : '7', 'name' : 'RO'}
    ,{'id' : '8', 'name' : 'PT'},{'id' : '9', 'name' : 'PL'},{'id' : '10', 'name' : 'NO'},{'id' : '11', 'name' : 'NL'}
    ,{'id' : '12', 'name' : 'LV'},{'id' : '13', 'name' : 'LT'},{'id' : '14', 'name' : 'IT'},{'id' : '15', 'name' : 'IS'}
    ,{'id' : '16', 'name' : 'HU'},{'id' : '17', 'name' : 'HR'},{'id' : '18', 'name' : 'HE'},{'id' : '19', 'name' : 'FR'}
    ,{'id' : '20', 'name' : 'FI'},{'id' : '21', 'name' : 'ET'},{'id' : '22', 'name' : 'ES'},{'id' : '23', 'name' : 'EN'}
    ,{'id' : '24', 'name' : 'EL'},{'id' : '25', 'name' : 'DE'},{'id' : '26', 'name' : 'DA'},{'id' : '27', 'name' : 'CS'}
    ,{'id' : '28', 'name' : 'CA'},{'id' : '29', 'name' : 'BG'},{'id' : '30', 'name' : 'AR'}]
    selectedLanguages = [];
    languageMessage = '';
    languageSettings = {};
    AdminForm: FormGroup;
    AdminFormDetails: any;
    isDisabled = true;
    countrySettings = {};
    report_json = {};
    action:string;
    id:string;
    templateObj :any = {};
    showLoader = false;
    actionTitle:string;
    ckeditorContent:any="";
    passwordEditorContent:any="";
    templateMessage='';
    passwordTemplateMessage = '';
    enableSubmit:boolean = false;
    
    constructor(private sessionHandler:SessionHandler, public httpService : HttpService, public dialog: MatDialog, private formBuilder: FormBuilder
        ,private activatedRoute: ActivatedRoute,private router: Router, private oktaAuthStateService: OktaAuthStateService,
        @Inject(OKTA_AUTH) private oktaAuth: OktaAuth
    ) {
        this.oktaAuthStateService.authState$.subscribe(async (authState) => {
            if (authState.isAuthenticated) {
                const tokens = await this.oktaAuth.tokenManager.getTokens();
                this.accessToken = tokens.accessToken?.accessToken;
                this.activatedRoute.params.subscribe(params => {
                    this.action = params['action'];
                });
                this.activatedRoute.queryParams.subscribe((params: Params) => {
                    this.id = params['id'];
                });
                if ("Create" === this.action) {
                    this.getDefaultFormData();
                    this.actionTitle = "Add";
                } else {
                    this.getEditForm(this.id);
                    this.actionTitle = "Edit";
                }
            } else {
                this.router.navigateByUrl('/extra/login');
            }
        });
    }
    public getEditForm(id){
        this.showLoader = true;

        let token = localStorage.getItem('userEmail');
        const httpOptions = {
          headers : new HttpHeaders({
                'Content-Type': 'application/json',
                // 'googleEmailId': token
                'Authorization': `Bearer ${this.accessToken}`

            }) };
        this.httpService.getRequestWithHeader('emailTemplate/edit/'+this.id, httpOptions).subscribe(
            res => {
                console.log(res);


                if(res['message'] == 'error_occured'){

                    this.showLoader = false;

                    this.httpService.onEnd();
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = res['exp']['message'];

                    this.dialogRef.afterClosed().subscribe(result => {
                        window.location.href = '#/app/emailTemplate/list';
                    });
                    return;
                 }
                this.report_json = res['dataMap'];
                // console.log(this.report_json);

                let countriesArr = this.report_json['countries'];
                this.templateObj = this.report_json['template'];

               console.log(this.templateObj);



                for (var i in countriesArr) {
                    var obj = { "id": i+'', "name": countriesArr[i] };
                    this.countries.push(obj);
                    if(this.templateObj.country==countriesArr[i]){
                        this.selectedCountries.push(obj);
                    }
                }

                for(var i in this.languages){
                    var lang = this.languages[i];
                    if(lang["name"]==this.templateObj.language){
                        this.selectedLanguages.push(lang);
                    }
                }

                this.templateObj.countriesData = this.selectedCountries;
                this.templateObj.languagesData = this.selectedLanguages;
                this.ckeditorContent = this.templateObj.templateHtml;
                this.passwordEditorContent = this.templateObj.passwordHtml;

                this.countryMessage = "";
                this.languageMessage = "";
                this.httpService.onEnd();
                this.showLoader = false;
                this.buildForm();
                this.AdminForm.patchValue(this.templateObj);
                this.onEditorChange(this);
                this.onPasswordEditorChange(this);

                },
                err => {
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = 'Failed to retrieve data.';
                    this.showLoader = false;
                    this.httpService.onEnd();
                    }
        );
    }
    public getDefaultFormData(){
        this.showLoader = true;
            let token = localStorage.getItem('userEmail');
            const httpOptions = {
              headers : new HttpHeaders({
                    'Content-Type': 'application/json',
                    // 'googleEmailId': token
                    'Authorization': `Bearer ${this.accessToken}`
                }) };
            this.httpService.getRequestWithHeader('emailTemplate/create', httpOptions).subscribe(
                res => {
                    console.log(res);

                    if(res['message'] == 'error_occured'){

                        this.showLoader = false;

                        this.httpService.onEnd();
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = res['exp']['message'];

                        this.dialogRef.afterClosed().subscribe(result => {
                            window.location.href = '#/app/emailTemplate/list';
                        });
                        return;
                     }


                    this.report_json = res['dataMap'];
                    console.log(this.report_json);

                    let countriesArr = this.report_json['countries'];

                    for (var i in countriesArr) {
                        var obj = { "id": i, "name": countriesArr[i] };
                        this.countries.push(obj);
                    }
                    this.httpService.onEnd();
                    this.showLoader = false;
                    },
                    err => {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = 'Failed to retrieve data.';
                        this.showLoader = false;
                        this.httpService.onEnd();
                        }
            );
          }

          onEditorChange(event){

            if(this.ckeditorContent.length==0){
                this.AdminFormDetails.validate = false;
                this.templateMessage = "Provide Doc Template Text";
                this.enableSubmit = false;
            }else{
                this.AdminFormDetails.validate = true;
                this.templateMessage = "";
                this.enableSubmit = true;
            }
          }

          onPasswordEditorChange(event){

            if(this.passwordEditorContent.length==0){
                this.AdminFormDetails.validate = false;
                this.passwordTemplateMessage = "Provide password Template Text";
                this.enableSubmit = false;
            }else{
                this.AdminFormDetails.validate = true;
                this.passwordTemplateMessage = "";
                this.enableSubmit = true;
            }
          }

    buildForm() {
        this.AdminForm = this.formBuilder.group({
             countriesData: this.formBuilder.control(null, [Validators.required]),
             languagesData: this.formBuilder.control(null, [Validators.required]),
             urlSubject: this.formBuilder.control(null, [Validators.required]),
             passwordSubject: this.formBuilder.control(null, [Validators.required]),
            //  templateHtml:this.formBuilder.control("", [Validators.required]),
        });

        this.AdminForm.valueChanges.subscribe(data => {
            this.AdminFormDetails = this.AdminForm.getRawValue();

            this.AdminFormDetails['countryId'] = [];

            this.AdminFormDetails['country'] = null;

            this.AdminFormDetails['languageId'] = [];

            this.AdminFormDetails['language'] = null;

            for (let d in this.AdminFormDetails.countriesData){
                this.AdminFormDetails['countryId'].push(this.AdminFormDetails.countriesData[d]['id']);
                this.AdminFormDetails['country']=this.AdminFormDetails.countriesData[d]['name'];
            }

            for (let d in this.AdminFormDetails.languagesData){
                this.AdminFormDetails['languageId'].push(this.AdminFormDetails.languagesData[d]['id']);
                this.AdminFormDetails['language']=this.AdminFormDetails.languagesData[d]['name'];
            }

              if(this.AdminFormDetails['countryId'].length==0){
                this.AdminFormDetails.validate = false;
                this.countryMessage = "Select Country";
                }else{
                    this.AdminFormDetails.validate = this.AdminForm.valid;
                    this.countryMessage = '';
                }

                if(this.AdminFormDetails['languageId'].length==0){
                    this.AdminFormDetails.validate = false;
                    this.languageMessage = "Select Language";
                    }else{
                        this.AdminFormDetails.validate = this.AdminForm.valid;
                        this.languageMessage = '';
                    }

                    if(this.ckeditorContent.length==0){
                        this.AdminFormDetails.validate = false;
                        this.templateMessage = "Provide Doc Template Text";
                    }else{
                        this.AdminFormDetails.validate = true;
                        this.templateMessage = "";
                    }
                    if(this.passwordEditorContent.length==0){
                        this.AdminFormDetails.validate = false;
                        this.passwordTemplateMessage = "Provide Password Template Text";
                    }else{
                        this.AdminFormDetails.validate = true;
                        this.passwordTemplateMessage = "";
                    }
        });

    }

    public validateConfig(config){
      if(config.templateHtml == null || config.templateHtml == ''){
        this.dialogRef = this.dialog.open(dialogComponent);
        this.dialogRef.componentInstance.msg = 'Please provide template content for URL template';
        return false;
      }
      if(config.templateHtml.indexOf('REPORT_URL') < 0){
        this.dialogRef = this.dialog.open(dialogComponent);
        this.dialogRef.componentInstance.msg = "Please add 'REPORT_URL' text in URL template";
        return false;
      }
      if(config.passwordHtml == null || config.passwordHtml == ''){
        this.dialogRef = this.dialog.open(dialogComponent);
        this.dialogRef.componentInstance.msg = 'Please provide template content for password template';
        return false;
      }
      if(config.passwordHtml.indexOf('REPORT_PASSWORD') < 0){
        this.dialogRef = this.dialog.open(dialogComponent);
        this.dialogRef.componentInstance.msg = "Please add 'REPORT_PASSWORD' text in password template";
        return false;
      }
      return true;
    }

    public saveAdminData(){

        // console.log(this.AdminForm.value);
        console.log(this.AdminFormDetails);

        const config = this.AdminFormDetails;
        config.templateHtml = this.ckeditorContent;
        config.passwordHtml = this.passwordEditorContent;
        config.id = this.id;
        if(!this.validateConfig(config)){
          return;
        }
        this.showLoader = true;

        let token = localStorage.getItem('userEmail');
        const httpOptions = {
          headers : new HttpHeaders({
                'Content-Type': 'application/json',
                // 'googleEmailId': token
                'Authorization': `Bearer ${this.accessToken}`
            }) };
        this.httpService.postRequestWithHeader(config,'emailTemplate/create',httpOptions).subscribe(
            res => { this.saveAdminResponse(res);

            },
            err => { this.httpService.onEnd();
                this.showLoader = false;
                this.dialogRef = this.dialog.open(dialogComponent);
                this.dialogRef.componentInstance.msg = 'Not able to save details. Please try again.';
                this.httpService.onEnd();
            }
        );
    }

    public saveAdminResponse(res){
        console.log(res);
            // var res = JSON.parse(res['_body']);
        if(res && res.message == 'success'){

            this.showLoader = false;

            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(dialogComponent);
            if(this.action=='Edit'){
                this.dialogRef.componentInstance.msg = "Template updated successfully.";
            }else{
                this.dialogRef.componentInstance.msg = "Template added successfully.";
            }
            this.dialogRef.afterClosed().subscribe(result => {
                window.location.href = '#/app/emailTemplate/list';
            });
        }else if(res && res.message == 'error_occured'){

            this.showLoader = false;

            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.exp.message;


         } else {
            this.showLoader = false;

            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Not able to save details. Please try again.';
            this.httpService.onEnd();
        }
    }

    ngOnInit() {
        this.buildForm();
        this.countrySettings = {
            singleSelection: true,
            text:"Select Country *",
            labelKey: "name",
            classes:"myclass custom-class"
        };

        this.languageSettings = {
            singleSelection: true,
            text:"Select Language *",
            labelKey: "name",
            classes:"myclass custom-class"
        };

          }
}
